// extracted by mini-css-extract-plugin
module.exports = {"container":"mO","imgContainer":"nO","content":"oO","brand":"pO","product":"qO","price":"rO","noLink":"sO"};